import { TextStyleConfig } from '../types';

export const styleConfig: TextStyleConfig = {
  baseStyle: {
    fontWeight: 'normal',
    color: 'grey.900',
  },
  // TODO: remove prefixes for letter spacing
  sizes: {
    'body-xxl': {
      fontSize: ['3xl', '4xl'],
      lineHeight: ['2.25rem', '2.5rem'], // TODO: Need a clarification on the mobile line height
      letterSpacing: 'less-tight',
    },
    'body-xl': {
      fontSize: '2xl',
      lineHeight: '2rem',
      letterSpacing: 'tight',
    },
    'body-lg': {
      fontSize: 'lg',
      lineHeight: '1.5rem',
      letterSpacing: 'tight',
    },
    'body-md': {
      fontSize: 'md',
      lineHeight: '1.5rem',
      letterSpacing: 'less-tight',
    },
    'body-sm': {
      fontSize: 'sm',
      lineHeight: '1rem',
      letterSpacing: 'less-tight',
    },
    'body-xs': {
      fontSize: 'xs',
      lineHeight: '1rem',
    },
  },
  variants: {
    'text-primary': {
      color: 'grey.900',
    },
    'text-secondary': {
      color: 'grey.600',
    },
    'text-disabled': {
      color: 'grey.300',
    },
  },
  defaultProps: {
    size: 'body-md',
    variant: 'text-primary',
  },
};
